// extracted by mini-css-extract-plugin
export default {"actionsContainer":"RecommendationCard_actionsContainer__404qZ","actionButton":"RecommendationCard_actionButton__7iSwN","cancelButton":"RecommendationCard_cancelButton__bbsmf"};